import React, { Fragment } from 'react';
import { TextFieldProps, TextField, Typography } from '@material-ui/core';

/**
 * Represents a text field filter component for the lead list.
 *
 * @param {TextFieldProps} {
 *     label,
 *     value,
 *     onChange,
 * }
 */
export const TextFieldFilter = ({
    label,
    value,
    onChange,
    ...props
}: TextFieldProps) => (
    <Fragment>
        <Typography
            variant="h6"
            data-testid="text-field-filter-label"
            style={{ minWidth: 85 }}
        >
            {label}
        </Typography>
        <TextField
            fullWidth
            variant="outlined"
            size="small"
            onChange={onChange}
            value={value}
            InputProps={{
                inputProps: {
                    'data-testid': 'text-field-filter-input',
                    style: {
                        fontSize: 16,
                    },
                },
            }}
            {...props}
        />
    </Fragment>
);
